import React, { Component } from 'react';

import { ResponsiveLine } from '@nivo/line';
import { chartColors } from './chartColors';

class LineGraphWithGridAndAxes extends Component {
  render() {
    var defaultLegends = [{ "anchor": "bottom-right",
                            "direction": "column",
                            "translateX": 500,
                            "itemWidth": 0,
                            "itemHeight": 0,
                            "symbolSize": 0,
                            "symbolShape": "circle"}];
    var defaultMargins = {"top": 20, "right": 50, "bottom": 80, "left": 80};

    return (
      <div style={{width: 100 + '%', height: this.props.height + 'px'}}>
        <ResponsiveLine
          data={this.props.data}
          margin={this.props.margins ? this.props.margins : defaultMargins}
          colors={this.props.colors ? this.props.colors : chartColors.yellows}
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
          stacked={this.props.stacked}
          axisBottom={{
            "orient": "bottom",
            "tickValues": 15,
            "tickSize": 10,
            "tickPadding": 5,
            "tickRotation": 90,
            "legend": "",
            "legendOffset": 50,
            "legendPosition": "center"
          }}
          axisLeft={{
            "orient": "left",
            "tickSize": 5,
            "tickPadding": 5,
            "tickRotation": 0,
            "legend": "",
            "legendOffset": 0,
            "legendPosition": "center"
          }}
          enableGridX={this.props.enableGridX}
          enableGridY={this.props.enableGridY}
          enableDots={false}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          isInteractive={this.props.isInteractive}
          enableStackTooltip={this.props.enableStackTooltip}
          legends={this.props.legends ? this.props.legends : defaultLegends}
        /> 
      </div>
    );
  }
  
}

export default LineGraphWithGridAndAxes;
